import { create } from 'zustand';
import { doctorQueueApi } from '@/api/doctor-queue-api';
import type { IncomingInvitationData } from '@/components/doctor/IncomingCallModal';

interface DoctorQueueStore {
  isOnline: boolean;
  isLoading: boolean;
  currentInvitation: IncomingInvitationData | null;
  setIsOnline: (online: boolean) => void;
  setCurrentInvitation: (invitation: IncomingInvitationData | null) => void;
  fetchStatus: () => Promise<boolean>;
  toggleOnline: () => Promise<boolean>;
}

export const useDoctorQueueStore = create<DoctorQueueStore>((set, get) => ({
  isOnline: false,
  isLoading: false,
  currentInvitation: null,

  setIsOnline: (online: boolean) => set({ isOnline: online }),

  setCurrentInvitation: (invitation: IncomingInvitationData | null) =>
    set({ currentInvitation: invitation }),

  fetchStatus: async () => {
    try {
      console.info('[DOCTOR-QUEUE-STORE] Consultando status oficial do médico no backend...');
      const res = await doctorQueueApi.getStatus();
      const online = res?.status === 'ONLINE';
      console.info('[DOCTOR-QUEUE-STORE] ✓ Status obtido:', { status: res?.status, isOnline: online, isExpressEnabled: res?.isExpressEnabled });
      set({ isOnline: online });
      return online;
    } catch (err) {
      console.warn('[DOCTOR-QUEUE-STORE] ⚠️ Erro ao consultar status, mantendo estado atual:', err);
      return get().isOnline;
    }
  },

  toggleOnline: async () => {
    const current = get().isOnline;
    const nextStatus = current ? 'OFFLINE' : 'ONLINE';
    console.info(`[DOCTOR-QUEUE-STORE] Alterando status do médico: ${current ? 'ONLINE' : 'OFFLINE'} -> ${nextStatus}`);
    set({ isLoading: true });
    try {
      await doctorQueueApi.updateStatus({ status: nextStatus });
      const online = nextStatus === 'ONLINE';
      console.info(`[DOCTOR-QUEUE-STORE] ✓ Status atualizado com sucesso para: ${nextStatus}`);
      set({ isOnline: online });
      return online;
    } finally {
      set({ isLoading: false });
    }
  },
}));
